import { Divider, DividerProps } from '@mui/material';
import { PropsWithChildren } from 'react';

export const CustomDivider = ({
  children,
  ...props
}: PropsWithChildren<DividerProps>) => {
  return (
    <Divider
      {...props}
      sx={{
        ...(props.sx ? props.sx : {}),
      }}
    >
      {children}
    </Divider>
  );
};
